import { useState } from 'react';
import { SimulationGetTasksFilterSortBy, SortOrder } from '@nexelem/graphne-api';

export type SimulationSortConfig = {
  sortBy?: SimulationGetTasksFilterSortBy;
  sortOrder?: SortOrder;
};

const DEFAULT_SORT: SimulationSortConfig = {
  sortBy: SimulationGetTasksFilterSortBy.PlannedStart,
  sortOrder: SortOrder.Asc,
};

export const useSortConfig = () => {
  const [sort, setSort] = useState<SimulationSortConfig>(DEFAULT_SORT);

  const toggleSort = (column: SimulationGetTasksFilterSortBy) => {
    setSort((prev) => {
      const sortOrder = prev.sortBy === column && prev.sortOrder === SortOrder.Asc ? SortOrder.Desc : SortOrder.Asc;
      return { sortBy: column, sortOrder };
    });
  };

  const getSortOrder = (column: SimulationGetTasksFilterSortBy): SortOrder | undefined =>
    sort.sortBy === column ? sort.sortOrder : undefined;

  return { sort, toggleSort, getSortOrder };
};
